module.exports = __webpack_public_path__ + "img/qr_code_2.eeeef9ea.jpg";